import React from "react";
import "./AboutCardStyle.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useAppContext } from "../../contexts/AppContext";
import { NavLink } from "react-router-dom";
import parse from "html-react-parser";
import { isImage, isVideo } from "../MediaFilter";
import thumbnail from "../../assets/doctors.jpg";

function AboutCard(Props) {
  const { CardItem, image, zigzag, apiEndPoint, profile, title, } = Props;
  const {
    translate,
    updateFullData,
    updateSelectedData,
    updateSelectedTitle,
    getImageUrl,
  } = useAppContext();


  return (
    <div className="card-parent-container animated">
      <div className={zigzag ? "card-wraper" : "card-wraper card-wraper-start"}>
        {Array.isArray(CardItem) && CardItem.length > 0 &&
          CardItem.map((CardItems, index) => (
            <div
              className={
                zigzag
                  ? "card-container card-container-margin"
                  : "card-container card-container-services "
              }
              key={index}
            >
              <div
                className={`${profile
                  ? "w-100 bg-light d-flex justify-content-center py-1"
                  : "card-icon"
                  }`}
              >
                {image === "photo" && (
                  <div className="card-photo-container">
                    {Array.isArray(CardItems?.images) && CardItems.images.length > 0 &&
                      (isImage(`${apiEndPoint}/${CardItems.images[0]}`) ? (
                        <img
                          src={getImageUrl(CardItems.images[0])}
                          alt={CardItems?.title || "photo"}
                          className={profile ? "card-profile-photo" : "card-photo"}
                        />
                      ) : isVideo(`${apiEndPoint}/${CardItems.images[0]}`) ? (
                        <img
                          src={thumbnail}
                          alt={"video thumbnail"}
                          className={profile ? "card-profile-photo" : "card-photo"}
                        />
                      ) : null)}
                  </div>
                )}
                {image === "icon" && (
                  <span className={`${CardItems?.icon}`}></span>
                )}
              </div>
              <div className="w-100 card-body d-flex flex-column justify-content-between align-items-center">
                <div className="px-3 w-100 d-flex flex-column align-items-center justify-content-center card-text-section">
                  <div>
                    <h6
                      className="card-title w-100 mb-2 text-center"
                      style={{ textTransform: "capitalize" }}
                    >
                      {parse(translate(CardItems?.title))}
                    </h6>
                  </div>
                  <div
                    className={`${profile
                      ? "card-contentss d-flex justify-content-center"
                      : "card-contentss"
                      }`}
                  >
                    <div>
                      {(() => {
                        const text = translate(CardItems?.content) || "";
                        const isTruncated = text.length > 160;
                        return (
                          <>
                            {parse(isTruncated ? text.slice(0, 155) + "..." : text)}
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>

                {/* Spacer to push button to bottom */}
                <div className="card-btn-spacer" />

                <NavLink
                  onClick={() => {
                    updateFullData(CardItem);
                    updateSelectedData(CardItems);
                    updateSelectedTitle(title);
                  }}
                  to={`/${title.toLowerCase() === 'doctor' ? 'doctors' : title.toLowerCase()}/${CardItems.id}`}
                  style={{ textDecoration: "none" }}
                  className="w-100 d-flex justify-content-center text-dark align-items-center  py-2 pointer read-more"

                >
                  <span>{parse(translate("Read More"))}</span>
                  <span className="bi bi-arrow-right px-2 "></span>
                </NavLink>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default AboutCard;
